import { useDispatch, useSelector } from "react-redux";
import { getUserObject } from "../../../../utils/getUserObject";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { getCreatedAtString } from "../../utils/helpers/notificationsHelpers/getCreatedAtString";
import SendMessageForm from "./MessageDrawerComponents/SendMessageForm";
import { useEffect, useRef, useState } from "react";
import { getPartOfferMessages } from "../../reduxStore/entities/messages";


const MessageDrawer = ({
    partOfferId,
    conversationUserIds
}) => {
    const messageContainerRef = useRef(null);

    const dispatch = useDispatch();

    const [loaded, setLoaded] = useState(false);

    const fetchedMessages = useSelector((state) => state.messages.partOfferMessages);

    const filterDto = {
        partOfferId: partOfferId,
    };


    useEffect(() => {
        dispatch(getPartOfferMessages(filterDto));
    }, []);

    //Scroll on bottom on focus and new message
    useEffect(() => {
        if (messageContainerRef.current) {
            messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
        };

        setLoaded(true);
    }, [fetchedMessages]);

    if (!loaded) {
        return null;
    };

    //We are reversing messages for display on Frontend 
    //because of the createdAt: "DESC" on the backend and Limit and Offset
    const reversedMessagesForDisplay = [...fetchedMessages].reverse();

    const GetRightMessageBubble = (message) => {
        return (
            <div
                key={message.ulid}
                style={styles.messageBubbleRight}
            >
                <p style={styles.rightMessageText}>
                    {message.body}
                </p>

                <p style={styles.createdAtRightText}>
                    {getCreatedAtString(message.createdAt)}
                </p>
            </div>
        );
    };

    const GetLeftMessageBubble = (message) => {
        return (
            <div
                key={message.ulid}
                style={styles.messageBubbleLeft}
            >
                <p style={styles.leftMessageText}>
                    {message.body}
                </p>

                <p style={styles.createdAtLeftText}>
                    {getCreatedAtString(message.createdAt)}
                </p>
            </div>
        );
    };


    const checkIfLoggedUserIsAuthor = (authorId) => {
        const loggedUserId = getUserObject()?.userid;
        return loggedUserId === authorId;
    };



    return (
        <div style={styles.mainContainer}>

            <div style={styles.titleComponent}>
                <p style={styles.title}>Poruke</p>
            </div>

            <div style={styles.contentWrapper}>
                <div
                    style={styles.messageContainer}
                    className="hide-scrollbar"
                    ref={messageContainerRef}
                >
                    {reversedMessagesForDisplay.map((message) => {
                        return checkIfLoggedUserIsAuthor(message.author_user_id)
                            ? GetLeftMessageBubble(message)
                            : GetRightMessageBubble(message);
                    })}
                </div>

            </div>

            <div style={styles.sendMessageFormWrapper}>
                <SendMessageForm
                    partOfferId={partOfferId}
                    conversationUserIds={conversationUserIds}
                />
            </div>

        </div>
    );

};

export default MessageDrawer;


const styles = {
    mainContainer: {
        width: "380px",
        height: "100vh",
        backgroundColor: "rgb(245, 245, 244)",
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        boxSizing: "border-box",
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "24px",
        marginBottom: "20px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    titleComponent: {
        marginTop: 30

    },
    contentWrapper: {
        flex: 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },
    messageContainer: {
        flex: 1,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        paddingRight: "5px",
        paddingBottom: "10px",
    },
    sendMessageFormWrapper: {

    },
    messageBubbleLeft: {
        backgroundColor: "rgb(243, 244, 246)",
        border: "1px solid rgb(203, 213, 225)",
        padding: "8px",
        borderRadius: "8px",
        maxWidth: "70%",
        alignSelf: "flex-start"
    },
    leftMessageText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.87)",
        textAlign: 'left',
        overflowWrap: "break-word",
        wordBreak: "break-word"
    },
    createdAtLeftText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "12px",
        color: "rgba(0, 0, 0, 0.7)"
    },
    messageBubbleRight: {
        backgroundColor: "rgb(25, 118, 210)",
        border: "1px solid rgb(25, 118, 210)",
        padding: "8px",
        borderRadius: "8px",
        maxWidth: "70%",
        alignSelf: "flex-end"
    },
    rightMessageText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "rgba(255, 255, 255, 1)",
        textAlign: 'left',
        overflowWrap: "break-word",
        wordBreak: "break-word"
    },
    createdAtRightText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "12px",
        color: "rgba(255, 255, 255, 0.7)"
    }
};
